import { FC } from "react";
import { pluralizeWithCount } from "@common/helpers/string";
import { buildInvoiceOrBillLockedSuffix } from "@components/transactions/matchedInvoiceOrBillLock";
import { buildScheduleLockedSuffix } from "@components/transactions/scheduleLock";
import { CommandsListProps } from "./lib";
import { TaskBulkOptionsCommandsList } from "./TaskBulkOptionsCommandsList";
import { useCommands } from "./useCommands";

export const TransactionBulkAccrualCoaCommandsList: FC<CommandsListProps> = ({
    options = {},
}) => {
    const { returnToRoot } = useCommands();
    const {
        selectedTransactionCount = 0,
        transactionBulkAccrualCoaOptions = [],
        transactionsLockedByInvoiceOrBillCount = 0,
        transactionsLockedByScheduleCount = 0,
    } = options;

    return (
        <TaskBulkOptionsCommandsList
            heading={`Set accrual ledger for ${pluralizeWithCount("transaction", selectedTransactionCount)}${buildInvoiceOrBillLockedSuffix(transactionsLockedByInvoiceOrBillCount)}${buildScheduleLockedSuffix(transactionsLockedByScheduleCount)}`}
            options={transactionBulkAccrualCoaOptions}
            onOptionSelected={returnToRoot}
        />
    );
};
